import React, { useState } from "react";
import {
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";
import "../sharepopup/sharepopup.css";

const SharePopUp = ({
  title = "Share Itinerary",
  shareurl,
  showmail,
  showwhatsapp,
  showfacebook,
  showLinkedin,
  onClose,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareurl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const openLink = (url) => {
    window.open(url, "_blank");
  };

  const iconBox = (tooltip, IconComponent, onClick, disabled = false) => (
    <div
      className="share-icon-wrapper"
      title={tooltip}
      onClick={!disabled ? onClick : undefined}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <div className="share-icon-box">
        <IconComponent size={24} color="rgba(2, 97, 158, 1)" />
      </div>
    </div>
  );

  return (
    <div className="share-popup-container">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0 sharetitle">{title}</h6>

        <span onClick={onClose} className="close-btn">
          ✕
        </span>
      </div>

      {/* Input */}
      <div className="mt-3">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            value={shareurl}
            readOnly
            onKeyDown={(e) => e.key === "Enter" && handleCopy()}
          />
          <span
            className="input-group-text copy-btn"
            onClick={handleCopy}
          >
            <MdContentCopy size={20} />
          </span>
        </div>
      </div>

      {/* Subheading */}
      <p className="mt-3 mb-2 sharetitle">
        Or share on:
      </p>

      {/* Icons */}
      <div className="d-flex gap-2 flex-wrap">
        {showmail &&
          iconBox("Email", FaEnvelope, () =>
            openLink(`mailto:?subject=Check this out&body=${shareurl}`)
          )}

        {showwhatsapp &&
          iconBox("WhatsApp", RiWhatsappFill, () =>
            openLink(`https://wa.me/?text=${encodeURIComponent(shareurl)}`)
          )}

        {showfacebook &&
          iconBox("Facebook", FaFacebookF, () =>
            openLink(
              `https://www.facebook.com/sharer/sharer.php?u=${shareurl}`
            )
          )}

        {showLinkedin &&
          iconBox("LinkedIn", FaLinkedinIn, () =>
            openLink(
              `https://www.linkedin.com/sharing/share-offsite/?url=${shareurl}`
            )
          )}
      </div>

      {/* Snackbar (Bootstrap Toast Alternative) */}
      {copied && (
        <div className="copy-toast">
          Link copied to clipboard!
        </div>
      )}
    </div>
  );
};

export default SharePopUp;